import TextButton from "@common/ui/TextButton";
import { useProjectDataStore } from "@state/projectDataStore";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { useStore } from "@state/store";
import gsap from "gsap";
import { useEffect } from "react";

function Sidebar_Splash() {
  const { splashData, brandingData } = useProjectDataStore((s) => ({
    splashData: s.splashData,
    brandingData: s.brandingData,
  }));
  const logo = brandingData?.logos[splashData?.logo];
  //
  const backgroundType = splashData?.splashBg;
  const backgroundMedia = backgroundType === "image/video"
    ? splashData?.splashBgMedia?.publicURL
    : `var(--${backgroundType})`;
  const isBackgroundMedia = backgroundMedia?.includes(".");
  const backgroundOpacity = splashData?.splashBgMediaOpacity;
  //
  const buttonBgColour = splashData?.buttonBgColour;

  const navigate = useNavigate();

  function animateSplash() {
    const t = gsap.timeline();

    t.to(".splashAnim", {
      autoAlpha: 1,
      ease: "power3.inOut",
      duration: 0.6,
    })
      .call(() => {
        navigate("the-location");
      })
      .to(".splashAnim", {
        autoAlpha: 0,
        ease: "power3.inOut",
        duration: 0.6,
        delay: 0.6,
      });
  }

  useEffect(() => {
    const t = gsap.timeline();

    t.fromTo(
      ".logo",
      {
        strokeDasharray: 1003.81,
        strokeDashoffset: 1003.81,
      },
      {
        strokeDasharray: 1003.81,
        strokeDashoffset: 0,
        ease: "circ.inOut",
        duration: 8,
        delay: 1,
      },
    )
      .to(
        ".logo",
        {
          autoAlpha: 1,
          duration: 1,
        },
        "<+0.5",
      )
      .to(".logo", {
        fill: "#CAAA75",
        duration: 0.6,
        delay: -4.5,
      })
      .to(
        ".london",
        {
          autoAlpha: 1,
          duration: 0.6,
          y: -15,
        },
        "<+0.25",
      )
      .to(
        ".button",
        {
          autoAlpha: 1,
          duration: 0.6,
          y: -15,
        },
        "<+0.25",
      );
  });

  return (
    <SplashWr
      style={{
        backgroundColor: "#754248",
      }}
      onClick={() => animateSplash()}
    >
      {
        /* {isBackgroundMedia &&
        (backgroundMedia?.includes(".mp4") ? (
          <SplashBgVideo
            style={{
              opacity: backgroundOpacity || 0.5,
              zIndex: -1,
            }}
            autoPlay
            muted
            loop
            playsInline
            src={backgroundMedia}
          />
        ) : (
          <SplashBgImg
            style={{
              opacity: backgroundOpacity || 0.5,
            }}
            src={backgroundMedia}
          />
        ))} */
      }
      <div className="logoAnim">
        <svg
          width="25rem"
          className="logo"
          viewBox="0 0 539 242"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M223 230.5H252.5M288 230.5H317.5M75.5 168H87V230.5H75.5V168ZM161 168H172V230.5H161V168ZM209.5 168H220V230.5H209.5V168ZM274 167.5H284.5V230.5H274V167.5ZM341 167.5H351.5V230.5H341V167.5ZM387.5 167.5H398.5V196V206.349C398.5 211.323 400.067 216.17 402.98 220.203L403.409 220.798C404.464 222.258 405.725 223.558 407.153 224.656C409.991 226.839 413.397 228.158 416.965 228.455L419.165 228.639C422.02 228.877 424.891 228.478 427.573 227.473C430.161 226.502 432.511 224.989 434.466 223.034L436.457 221.043C436.593 220.907 436.818 221.047 436.757 221.228C436.259 222.722 435.42 224.08 434.307 225.193L433.499 226.001C432.178 227.322 430.622 228.384 428.91 229.133L427.706 229.66C424.932 230.873 421.937 231.5 418.909 231.5H413.949C412.32 231.5 410.694 231.349 409.093 231.049C405.407 230.358 401.911 228.887 398.838 226.737L397.348 225.694C394.81 223.917 392.666 221.635 391.05 218.992C389.05 215.718 387.92 211.988 387.766 208.155L387.5 201.5V167.5Z"
            stroke="#CAAA75"
          />
          <path
            d="M440.5 168V216M472.5 174V230.5M472.5 168H484.5L505 202.5L523 173V176L500.5 215L472.5 168ZM526.5 168H538L537.5 230.5H526.5V168Z"
            stroke="#CAAA75"
          />
          <path
            d="M213 0.5H327M213 17H261.5M213 32.5H265M265 32.5H270M265 32.5V115H270V32.5M265 32.5V17H270V32.5M270 32.5H278.5M0 168H20M20 168H31.5V230H20V168ZM34.5 168H50.5M281.5 32.5H286.5V115H281.5V32.5ZM330 0.5H334V34H330V0.5ZM76 168H86.5V230H76V168Z"
            stroke="#CAAA75"
          />
          <path
            d="M102.5 168H90.5V169H101.716C102.237 169 102.757 169.057 103.265 169.17C105.662 169.703 107.76 171.14 109.122 173.183L110.188 174.782C112.649 178.474 113.721 182.919 113.212 187.327C112.75 191.335 111.006 195.087 108.241 198.025L107.792 198.502C105.691 200.734 102.762 202 99.6963 202H90.5V203.5H97.2294C99.3235 203.5 101.332 204.332 102.813 205.813C103.269 206.269 103.668 206.78 104 207.334L111 219L117.5 231H130L128.575 229.575C126.867 227.867 125.405 225.929 124.232 223.817L121 218L118.723 213.446C116.952 209.904 114.119 207.004 110.619 205.151L107.5 203.5L113.111 201.536C115.993 200.528 118.583 198.827 120.654 196.583L121.041 196.164C122.66 194.41 123.869 192.318 124.581 190.039L124.69 189.692C125.545 186.956 125.592 184.031 124.825 181.268C123.965 178.173 122.126 175.438 119.584 173.474L118.072 172.306C114.46 169.514 110.023 168 105.458 168H102.5Z"
            stroke="#CAAA75"
          />
        </svg>

        <SplashLogo className="london" src="/assets/imgs/london.png" />
      </div>

      <Button className="button" onClick={() => animateSplash()}>
        <span>EXPLORE</span>
      </Button>
    </SplashWr>
  );
}

const SplashWr = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  z-index: 200 !important;

  .logoAnim {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2.5rem;
  }

  .logo {
    opacity: 0;
  }

  .button {
    opacity: 0;
  }
`;

const SplashBgImg = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  object-fit: cover;
`;
const SplashBgVideo = styled.video`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  object-fit: cover;
`;

const SplashLogo = styled.img`
  width: 50%;
  opacity: 0;
`;

const Button = styled.div`
  letter-spacing: 3px;
  padding: 1.5rem;
  font-size: 1.25rem;
  border-radius: 5px;
  background-color: var(--accent);
  cursor: pointer;

  & span {
    display: inline-block;
    width: 100%;
    text-align: center;
    transform: translateX(4%);
  }

  img {
    transform: rotate(90deg);
  }
`;

export default Sidebar_Splash;
